// extracted by mini-css-extract-plugin
export default {"Collapsible":"Collapsible_Collapsible__7n8I0","Content":"Collapsible_Content__xKBNa"};